import { CountryCodeMaps } from "@core/dictionary/specific-country-list";

// The flag set the profile pages already load.
const FLAG_BASE = "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3";

/** The flag image of a country, by its name ("Sri Lanka", "UNITED STATES"); undefined when the name is not a known country. */
export function countryFlagUrl(name: string | number | null | undefined): string | undefined {
  if (typeof name !== "string") return undefined;
  const code = (CountryCodeMaps as Record<string, string>)[name.trim().toLowerCase()];
  return code ? `${FLAG_BASE}/${code.toLowerCase()}.svg` : undefined;
}

/** Whether a column's values are country names, going by its header ("Country", "Top Destination", "Origin Country"). */
export const isCountryColumn = (header: string): boolean => /country|destination|origin/i.test(header);
